import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirlinesFilterController } from "./useAirlinesFilter.controller";
import AirlinesFilterItem from "./AirlinesFilterItem";
import { AirlinesFilterOptions } from "./AirlinesFilterOptions";
import { Link, Stack } from "@bookingcom/bui-react";

export const AirlinesFilterMobile = () => {
  const {
    isFilterAvailable,
    title,
    resetLabel,
    showReset,
    onClickReset,
    options,
    value,
    onChange,
    optionsLimit,
    areOptionsTrucanted,
    optionsTogglerLabel,
    optionsTogglerIcon,
    onTogglerClick,
    selectAllTogglerLabel,
    deselectAllTogglerLabel,
    onSelectAll,
    isSelectAllDisabled,
    onDeselectAll,
    isDeselectAllDisabled
  } = useAirlinesFilterController();

  if (!isFilterAvailable) return null;

  return (
    <FilterSection
      attributes={{ "data-testid": "airlines_filter" }}
      resetAttributes={{ "data-testid": "search_filter_airline_reset" }}
      title={title}
      resetLabel={resetLabel}
      showReset={showReset}
      onClickReset={onClickReset}
    >
      <Stack direction="row">
        <Link onClick={onSelectAll} disabled={isSelectAllDisabled}>
          {selectAllTogglerLabel}
        </Link>
        <Link onClick={onDeselectAll} disabled={isDeselectAllDisabled}>
          {deselectAllTogglerLabel}
        </Link>
      </Stack>
      <AirlinesFilterOptions
        gap={4}
        togglerLabel={optionsTogglerLabel}
        togglerIcon={optionsTogglerIcon}
        onTogglerClick={onTogglerClick}
        options={options}
        optionsLimit={optionsLimit}
        areOptionsTrucanted={areOptionsTrucanted}
        renderOption={({ option, isHidden, index }) => (
          <AirlinesFilterItem
            key={`${index}-${option.value}`}
            value={option.value}
            label={option.label}
            count={option.count}
            checked={value.includes(option.value)}
            onChange={onChange}
            isHidden={isHidden}
          />
        )}
      />
    </FilterSection>
  );
};
